import { render, staticRenderFns } from "./VendorIndex.vue?vue&type=template&id=10271dda&scoped=true&"
import script from "./VendorIndex.vue?vue&type=script&lang=js&"
export * from "./VendorIndex.vue?vue&type=script&lang=js&"
import style0 from "./VendorIndex.vue?vue&type=style&index=0&id=10271dda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10271dda",
  null
  
)

export default component.exports